import { FC, SVGProps } from "react";

type ChevronIconProps = SVGProps<SVGSVGElement> & {
  direction?: "up" | "down" | "left" | "right";
};

export const ChevronIcon: FC<ChevronIconProps> = ({
  fill,
  className,
  width = 16,
  height = 8,
  direction = "down",
  style,
  ...props
}) => {
  const getRotation = () => {
    switch (direction) {
      case "up":
        return "180deg";
      case "left":
        return "90deg";
      case "right":
        return "-90deg";
      case "down":
      default:
        return "0deg";
    }
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 16 8`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        ...style,
        transform: `rotate(${getRotation()})`,
        transition: "transform 0.2s ease-in-out",
      }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.430571 0.511905C0.700138 0.19741 1.17361 0.160989 1.48811 0.430556L8.00001 6.01219L14.5119 0.430556C14.8264 0.16099 15.2999 0.197411 15.5695 0.511905C15.839 0.8264 15.8026 1.29987 15.4881 1.56944L8.48811 7.56944C8.20724 7.81018 7.79279 7.81018 7.51192 7.56944L0.51192 1.56944C0.197426 1.29987 0.161005 0.826399 0.430571 0.511905Z"
        fill={fill}
      />
    </svg>
  );
};
